// extracted by mini-css-extract-plugin
export default {"colocaciones-edit-container":"Colocadores_colocaciones-edit-container__Eekhx","colocaciones-edit-form":"Colocadores_colocaciones-edit-form__QqOsq"};